import { useToggle } from '../UNSAFE_useToggle';

export type TouchOptions = {
  isDisabled?: boolean;
};

/**
 * Get status on whether target has touch or not
 * @returns
 */
export function useTouch(settings: TouchOptions = { isDisabled: false }): {
  isTouch: boolean;
  touchProps: Record<string, any>;
} {
  const { bool, setTrue, setFalse } = useToggle(false);
  const touchProps = settings.isDisabled
    ? {}
    : {
        onTouchStart: setTrue,
        onTouchEnd: setFalse
      };
  return {
    isTouch: settings.isDisabled ? false : bool,
    touchProps: touchProps
  };
}
